const buttons = document.querySelector('.header-buttons-section');
const buttons_mobile = document.querySelector('.header-appointment-button-mobile');

window.addEventListener('scroll', () => {
  if(window.scrollY >200) {
    buttons.classList.add('buttons-scrolled');
  } else {
    buttons.classList.remove('buttons-scrolled');
  }

  if(window.scrollY >50) {
    buttons_mobile.classList.add('button-scrolled-mobile');
  } else {
    buttons_mobile.classList.remove('button-scrolled-mobile');
  }
});
